import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types/api';
import { IUserBalanceApiListResponse } from '@/types/userBalance';

export const userBalanceList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IUserBalanceApiListResponse>> => {
    return axios.get('/api/balance/list', { ...config, params });
};

export const userBalanceDetail = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IUserBalanceApiListResponse>> => {
    return axios.get('/api/balance/detail', { ...config, params });
};
